import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { lighten } from '@mui/system';

const ReadTimeChart = ({ data, colour, chartHeight = 300 }) => {
    const ref = useRef(null);

    const deviceData = data ? Object.keys(data).map((key) => ({ name: `${key[0].toUpperCase()}${key.slice(1)}`, value: data[key] })) : null;

    const noData = !deviceData?.find(e => e.value > 0);

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: params => `<b>${params.marker} ${params.name}</b></br>${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(params.value)} instances`
        },
        legend: {
            show: !noData
        },
        series: [
            {
                name: 'Read Time',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                labelLine: {
                    show: false
                },
                data: noData ? [] : deviceData,
                color: [lighten(colour, 0.8), lighten(colour, 0.4), colour]
            }
        ]
    };

    return (
        <ReactECharts
            option={options}
            style={{ height: chartHeight }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default ReadTimeChart;